/* Purpose: Footer with basic contact details and a sign out button if the user is signed in
 * Props: signOutRedirect (func) --optional
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React from "react";
import SubmitButton from "../Components/Button";
import '../custom.scss'

const Footer = (props) => {
    return(
        <div className='text-center align-items-center footer'>
            {/* If the footer needs a sign out button */}
            {props.signOutRedirect && (
                <div className='signout-btn align-items-center w-100'>
                    <SubmitButton onClick={props.signOutRedirect} text = 'Sign out' width = "75" />
                </div>
            )}
            <p>CONTACT US: info@iskamortgage.com</p>
            <p>©2023 ISKA MORTGAGE</p>
        </div>
    )
}

export default Footer;